/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Ats_ScoreInputs */

const en_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS score check`)
};

const de_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Score-Check`)
};

const fr_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score ATS`)
};

const es_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación ATS`)
};

const it_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio ATS`)
};

const nl_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-score`)
};

const pl_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik ATS`)
};

const fi_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-pisteet`)
};

const da_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-score`)
};

const sv_pricing_compare_ats_score = /** @type {(inputs: Pricing_Compare_Ats_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-betyg`)
};

/**
* | output |
* | --- |
* | "ATS score check" |
*
* @param {Pricing_Compare_Ats_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_ats_score = /** @type {((inputs?: Pricing_Compare_Ats_ScoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Ats_ScoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_ats_score(inputs)
	if (locale === "fr") return fr_pricing_compare_ats_score(inputs)
	if (locale === "es") return es_pricing_compare_ats_score(inputs)
	if (locale === "it") return it_pricing_compare_ats_score(inputs)
	if (locale === "nl") return nl_pricing_compare_ats_score(inputs)
	if (locale === "pl") return pl_pricing_compare_ats_score(inputs)
	if (locale === "fi") return fi_pricing_compare_ats_score(inputs)
	if (locale === "da") return da_pricing_compare_ats_score(inputs)
	if (locale === "sv") return sv_pricing_compare_ats_score(inputs)
	return en_pricing_compare_ats_score(inputs)
});